<!-- 使用 list-type 属性来设置文件列表的样式 -->
<template>
	<div class="image-upload">
		<el-upload
			:class="{ hide: fileList.length >= limit }"
			list-type="picture-card"
			:data="additionalData"
			:headers="headers"
			:action="uploadImgUrl"
			:before-upload="handleBeforeUpload"
			:on-success="handleUploadSuccess"
			:on-preview="handlePreview"
			:on-remove="handleRemove"
			:on-error="handleUploadError"
			:on-exceed="handleUploadExceed"
			:show-file-list="true"
			:file-list="fileList"
			:limit="limit">
			<el-icon class="avatar-uploader-icon"><plus /></el-icon>
		</el-upload>
		<!-- 上传提示 -->
		<div class="el-upload__tip" v-if="showTip">
			请上传
			<template v-if="fileSize">
				大小不超过
				<b style="color: #f56c6c">{{ fileSize }}MB</b>
			</template>
			<template v-if="fileType">
				格式为
				<b style="color: #f56c6c">{{ fileType.join('/') }}</b>
			</template>
			的文件
		</div>

		<el-dialog v-model="dialogVisible" title="预览" width="800px" append-to-body>
			<img :src="dialogImageUrl" style="display: block; max-width: 100%; margin: 0 auto" />
		</el-dialog>
	</div>
</template>

<script setup>
import { getToken } from '@/utils/auth'
import { checkFileUpload } from '@/utils/scm'
import { listToString, useImageUrl } from '@/utils/dynamic'
import defaultSettings from '@/settings'

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
	modelValue: [String, Object, Array],
	// 图片数量限制
	limit: {
		type: Number,
		default: 5
	},
	// 大小限制(MB)
	fileSize: {
		type: Number,
		default: 5
	},
	// 文件类型, 例如['png', 'jpg', 'jpeg']
	fileType: {
		type: Array,
		default: () => ['png', 'jpg', 'jpeg', 'gif']
	},
	// 是否显示提示
	isShowTip: {
		type: Boolean,
		default: true
	}
})

const { proxy } = getCurrentInstance()

const uploadImgUrl = ref(defaultSettings.fileUploadUrl) // 上传的图片服务器地址
const additionalData = ref({
	belongApp: defaultSettings.app,
	belongAppId: defaultSettings.appId
})

const headers = ref({ Authorization: 'Bearer ' + getToken() })

const dialogImageUrl = ref('')
const dialogVisible = ref(false)
const fileList = ref([]) //显示的列表
const modeList = ref([]) //正确的列表

const showTip = computed(() => props.isShowTip && (props.fileType || props.fileSize))

//使用 before-upload 限制用户上传的图片格式和大小
function handleBeforeUpload(file) {
	return checkFileUpload(file, props.fileType, props.fileSize)
}

//上传成功, 数据双向绑定
function handleUploadSuccess(file, files) {
	window.console.log(file, files)
	modeList.value = []
	if (res.ResData) {
		//当前上传的临时URL
		let curUrl = files.url
		//当前上传正确的图片信息
		let cname = res.ResData.FileName
		let cicon = res.ResData.FilePath
		//把临时的指替换成正确的指
		fileList.value.forEach((item, index) => {
			let name = item.name
			let url = item.url
			if (item.url == curUrl) {
				name = cname
				url = cicon
			}
			modeList.value.push({ name: name, url: url })
		})
		//更新正确的值用于提交到后端
		emit('update:modelValue', listToString(modeList.value))
	}
}

// 预览
function handlePreview(file) {
	dialogImageUrl.value = file.url
	dialogVisible.value = true
}

// 删除图片
function handleRemove(file, fileList) {
	const findex = fileList.value.map((f) => f.name).indexOf(file.name)
	if (findex > -1) {
		modeList.value.splice(findex, 1)
		emit('update:modelValue', listToString(modeList.value))
	}
}

// 上传失败
function handleUploadError() {
	proxy.$modal.msgError('上传失败')
	proxy.$modal.closeLoading()
}

// 文件个数超出
function handleUploadExceed() {
	proxy.$modal.msgError(`上传文件数量不能超过 ${props.limit} 个!`)
}

watch(
	() => props.modelValue,
	(val) => {
		if (val != null && val != '') {
			// 首先将值转为数组
			let list = Array.isArray(val) ? val : val.split(',')
			// 然后将数组转为对象数组
			fileList.value = list.map((item) => {
				if (typeof item === 'string') {
					//显示时加路径
					return { name: item, url: useImageUrl(item) }
				}
			})
		}
	},
	{
		immediate: true,
		deep: true
	}
)
</script>

<style scoped lang="scss">
.image-upload {
	// .el-upload--picture-card 控制加号部分
	.el-upload__tip {
		padding-left: 10px;
	}
	:deep(.hide .el-upload--picture-card) {
		display: none;
	}

	// 去掉动画效果
	:deep(.el-list-enter-active),
	:deep(.el-list-leave-active) {
		transition: all 0s;
	}

	:deep(.el-list-enter, .el-list-leave-active) {
		opacity: 0;
		transform: translateY(0);
	}
}
</style>
